<template>
    <div
        v-if="data !== ''"
        class="map-legend"
    >
        <div
            v-if="titleName !== ''"
            class="legend-title"
        >
            {{ $t('App.Legend.Title.' + titleName) }}
        </div>
        <!-- eslint-disable vue/no-v-html -->
        <span
            class="legend"
            v-html="data"
        />
        <!--eslint-enable-->
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-facing-decorator"

    /** Kartan legenda */
    @Component
    export default class MapLegend extends Vue {
        /** legendassa näytettävä sisältö */
        @Prop({ type: String, default: "TODO-tämä on legenda" }) data!: string
        /** Legendin otsikko. Haetaan kielitermeistä. ResourceKey on muotoa App.Legend.Title.[Rightslotin nimi]. */
        /** Kielitermi pitää muistaa lisätä (tyhjänä) manualiin samalla kun toteuttaa uuden legendin. */
        /** Otsikon teksti lisätään tarvittaessa kielitermieditorissa. */
        @Prop({ type: String, default: "" }) titleName!: string
    }
</script>

<style>
    .map-legend {
        padding: 20px 20px;
        background-color: white;
    }
    /*Legend specific*/
    /*Mikäli legendillä otsikko, sen tulisi olla h2*/
    .legend h2 {
        text-align: center;
        font-size: 1rem;
        margin: 2px 12px 8px;
        color: #777;
    }

    .legend span {
        position: relative;
        bottom: 3px;
    }

    .legend i {
        width: 1.125rem;
        height: 1.125rem;
        float: left;
        margin: 4px 8px 0 0;
        opacity: 0.7;
        border: 2px solid #6D6D6D;
    }

    .legend b {
        width: 1.125rem;
        height: 0.125rem;
        float: left;
        margin: 4px 8px 0 0;
        opacity: 0.7;
        border: none;
    }

    .legend img {
        width: 18px;
        height: 31px;
        margin: 0 8px 8px 0;
    }

    .legend-title {
        font-size: 1.125rem;
        margin-top: 0px;
        margin-bottom: 10px;
    }

    /* Rivitetään legend itemin teksti, jos menee yli legendin maksimi leveyden */
    .legend-item {
        display: flex;
        align-items: center;
        white-space: nowrap;
        padding-right: 5px;
    }
    .legend-item div:nth-child(1) {
        display: inline-block;
        vertical-align: top;
    }
    .legend-item div:nth-child(2) {
        display: inline-block;
        white-space: normal;
    }

    /* --- Huom.1100 vastaa DISPLAY_TYPES -kokoa M --- */
    @media (max-width: 1100px) {
        div.legend-item {
            white-space: nowrap;
            display: inline-flex;
            min-width: 255px;
            padding-bottom: 7px;
            margin-left: 10px;
        }
    }

    @media (min-width: 1100px) {
        .map-legend {
            max-width: 350px;
        }
    }
</style>
